import React from 'react';
import { Flex, ButtonV2 } from '@withjoy/joykit';
import { Header, Offer, BasicNote } from './components';
import { GetDataForThanksForRSVPQuery } from '@graphql/generated';
import { useCongratulationsController } from './Congratulations.controller';
import { linkButtonOverrides } from '@apps/saveTheDate/components/Shared.styles';
import { Confetti, Footer } from '../shared';

interface CongratulationsProps
  extends Readonly<{
    eventHandle: string;
    queryData?: GetDataForThanksForRSVPQuery;
  }> {}

export const Congratulations: React.FC<CongratulationsProps> = ({ eventHandle, queryData }) => {
  const { isVersionA, showPreview, setShowPreview, message, setMessage, tCongratulationsCard, handleBackToWebsite } = useCongratulationsController(eventHandle);

  return (
    <>
      <Flex
        paddingBottom={['24px', null, '64px']}
        flexDirection="column"
        width={['100%', null, '540px']}
        borderRadius={['0', null, '12px']}
        boxShadow="0px 9px 36px -30px rgba(0, 0, 0, 0.04), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 3px 8px 0px rgba(0, 0, 0, 0.03)"
      >
        <Confetti />
        <Header
          queryData={queryData}
          withMessage
        />
        {isVersionA && !showPreview && (
          <BasicNote
            setShowPreview={setShowPreview}
            message={message}
            setMessage={setMessage}
            eventHandle={eventHandle}
            queryData={queryData}
          />
        )}
        {(!isVersionA || (isVersionA && showPreview)) && (
          <Flex
            paddingX={['24px', null, '0']}
            alignItems="center"
            justifyContent="center"
          >
            <Offer
              message={message}
              setMessage={setMessage}
              eventHandle={eventHandle}
              queryData={queryData}
            />
          </Flex>
        )}
        <ButtonV2
          size="lg"
          onClick={handleBackToWebsite}
          variant="ghost"
          overrides={linkButtonOverrides}
          marginTop="48px"
        >
          {tCongratulationsCard.backToEventWebsite()}
        </ButtonV2>
      </Flex>
      <Footer marginY={7} />
    </>
  );
};
